import { render } from "./AccessControlBanner.vue?vue&type=template&id=34b44c4d&scoped=true"
import script from "./AccessControlBanner.vue?vue&type=script&lang=js"
export * from "./AccessControlBanner.vue?vue&type=script&lang=js"

import "./AccessControlBanner.vue?vue&type=style&index=0&id=34b44c4d&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b44c4d"]])

export default __exports__